<template>
    <div class="rush-order-auth-apply">
        <ApplyProcess v-if="tab === TABS[0]" @valid="handleValid"></ApplyProcess>
        <ValidResult v-else-if="tab === TABS[1]" @valid="handleValid"></ValidResult>
    </div>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import ApplyProcess from './ApplyProcess.vue';
import ValidResult from './ValidResult.vue';
import { TABS } from './config.js';

export default {
    components: { Paper, ApplyProcess, ValidResult },
    data() {
        return {
            TABS,
            tab: TABS[0]
        };
    },
    methods: {
        handleValid(tab) {
            this.tab = tab
        }
    }
};
</script>
